// Central content + config for Jet Cleaning Service.
// NOTE: Phone & email below are professional placeholders — edit to your real details.

export const CONTACT = {
  phoneDisplay: "214-418-3553",
  phoneHref: "tel:+12144183553",
  city: "Denton, Texas",
  hours: "Mon–Sat: 7AM – 7PM • Sun: By Appointment",
  googleUrl: "https://www.google.com/maps/search/?api=1&query=Jet+Cleaning+Service+Dallas+Fort+Worth",
};

export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_275e45af-08bc-4081-b14d-43e26f1de654/artifacts/m6pplztk_Jet%20Cleaning.jpg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80&auto=format",
  apartment1:
    "https://images.pexels.com/photos/8082227/pexels-photo-8082227.jpeg?auto=compress&cs=tinysrgb&w=1200",
  apartment2:
    "https://images.pexels.com/photos/6207816/pexels-photo-6207816.jpeg?auto=compress&cs=tinysrgb&w=1200",
  apartment3:
    "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80&auto=format",
  commercial:
    "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80&auto=format",
  residential:
    "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80&auto=format",
  residential2:
    "https://images.unsplash.com/photo-1631510390389-c1e4fb20ff31?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80&auto=format",
  team: "https://images.pexels.com/photos/9462636/pexels-photo-9462636.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const NAV_LINKS = [
  { label: "Apartments", id: "apartments" },
  { label: "Commercial", id: "commercial" },
  { label: "Residential", id: "residential" },
  { label: "Services", id: "services" },
  { label: "Service Area", id: "service-area" },
  { label: "Careers", id: "careers" },
  { label: "FAQ", id: "faq" },
];

export const TRUST_CARDS = [
  {
    title: "Reliable Every Time",
    body: "We show up when promised and respect your schedule — no missed appointments, no surprises.",
    icon: "ShieldCheck",
  },
  {
    title: "Clear Communication",
    body: "Friendly, responsive communication before, during, and after every cleaning.",
    icon: "ChatCircleText",
  },
  {
    title: "Consistent Quality",
    body: "Carefully selected cleaning professionals who deliver detailed, dependable results.",
    icon: "Sparkle",
  },
];

export const PROBLEMS = [
  { n: "01", text: "Cleaners who don't show up" },
  { n: "02", text: "Poor communication" },
  { n: "03", text: "Different cleaners every visit" },
  { n: "04", text: "Rushed work" },
  { n: "05", text: "Missed details" },
];

export const APARTMENT_SERVICES = [
  "Make Ready Cleaning",
  "Move Out Cleaning",
  "Move In Cleaning",
  "Clubhouse Cleaning",
  "Leasing Offices",
  "Fitness Centers",
  "Hallways",
  "Common Areas",
];

export const SERVICES = [
  { name: "Apartment Turnovers", icon: "Buildings", tag: "Specialty", slug: "apartment-turnover-cleaning-denton-tx" },
  { name: "Make Ready Cleaning", icon: "Broom", tag: "Apartments", slug: "make-ready-cleaning-denton-tx" },
  { name: "Move In / Move Out", icon: "Truck", tag: "Turnover", slug: "move-out-cleaning-denton-tx" },
  { name: "Commercial Cleaning", icon: "Briefcase", tag: "Business", slug: "commercial-cleaning-denton-tx" },
  { name: "Office Cleaning", icon: "Desktop", tag: "Business", slug: "office-cleaning-denton-tx" },
  { name: "Common Area Cleaning", icon: "Elevator", tag: "Property" },
  { name: "Residential Cleaning", icon: "House", tag: "Home", slug: "house-cleaning-denton-tx" },
  { name: "Deep Cleaning", icon: "Sparkle", tag: "Home", slug: "deep-cleaning-denton-tx" },
  { name: "Recurring Cleaning", icon: "ArrowsClockwise", tag: "Home", slug: "recurring-cleaning-denton-tx" },
  { name: "One-Time Cleaning", icon: "Star", tag: "Home" },
  { name: "Post Construction", icon: "HardHat", tag: "Specialty" },
  { name: "Vacant Unit Cleaning", icon: "Key", tag: "Apartments", slug: "make-ready-cleaning-denton-tx" },
];

export const SCHEDULE_FEATURES = [
  "Flexible Scheduling",
  "Day or Evening Appointments",
  "Same-Day Service (when available)",
  "Next-Day Service (when available)",
  "Weekly",
  "Bi-Weekly",
  "Monthly",
  "One-Time",
  "As Needed",
  "No Service Minimums in Primary Area",
];

export const BADGES = [
  "Licensed & Insured",
  "Locally Owned",
  "Satisfaction Focused",
  "Responsive Service",
];

export const FAQS = [
  {
    q: "How quickly can you turn around a vacant apartment unit?",
    a: "For apartment communities, we prioritize fast turnaround so units get back on the market quickly. In our primary service area we frequently offer same-day and next-day make-ready cleaning when availability allows. Tell us your turn schedule and we'll build a plan around it.",
  },
  {
    q: "Do you offer recurring cleaning options?",
    a: "Yes. We offer weekly, bi-weekly, monthly, one-time, and as-needed service. Recurring clients get consistent teams and priority scheduling so you always know what to expect.",
  },
  {
    q: "What areas do you serve?",
    a: "We proudly serve all of Dallas/Fort Worth, Texas. Not sure if you're in range? Request a quote and we'll confirm right away.",
  },
  {
    q: "Are there any service minimums?",
    a: "No service minimums within our primary service area. Whether it's a single vacant unit or an entire property, we're happy to help.",
  },
  {
    q: "What can I expect from a cleaning?",
    a: "Clear communication up front, a dependable team that arrives on schedule, meticulous attention to detail, and a follow-up to make sure you're satisfied. Consistency is our promise.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes — Jet Cleaning Service is locally owned and operates as a licensed and insured cleaning company for your peace of mind.",
  },
];

export const CAREER_BENEFITS = [
  { title: "Flexible Schedule", icon: "CalendarCheck" },
  { title: "Competitive Pay", icon: "CurrencyDollar" },
  { title: "Consistent Work", icon: "ChartLineUp" },
  { title: "Professional Support", icon: "Handshake" },
];

export const SERVICE_OPTIONS = [
  "Apartment / Make Ready Cleaning",
  "Move In / Move Out Cleaning",
  "Commercial / Office Cleaning",
  "Residential Cleaning",
  "Deep Cleaning",
  "Recurring Cleaning",
  "Post Construction Cleaning",
  "Not sure yet",
];
